import React, { useEffect } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import CommonContainer from "../../containers/Common";

interface Props {
  meganetLensMasterId: number | undefined,
  onChange: (newValue: any) => void,
}

export default ((props) => {

  const commonContainer = CommonContainer.useContainer();
  const meganetLensMasterId = props.meganetLensMasterId || commonContainer.getDefaultLensMasterId(0);

  useEffect(() => {
    if (props.meganetLensMasterId === undefined) {
      props.onChange(meganetLensMasterId);
    }
  }, []);

  return (
    <Select style={{ fontSize: 12, maxWidth: 240, width: '100%' }} value={meganetLensMasterId} onChange={(event) => props.onChange(event.target.value as number)}>
      {commonContainer.getLensesByMasterId(meganetLensMasterId).map(lens => (
        lens.lensType === 0 && <MenuItem key={lens.meganetLensMasterId} value={lens.meganetLensMasterId}>{lens.lensName}</MenuItem>)
      )}
    </Select>
  );
}) as React.FC<Props>;
